import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { DockOverviewFacade } from './dock-overview.facade';
import { setInitialStoreState } from '../../../../../../common/utils';

@Injectable({
  providedIn: 'root',
})
export class DockCreationGuard {
  constructor(private dockOverviewFacade: DockOverviewFacade) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    const { cloneDockId } = route.queryParams;
    if (cloneDockId) {
      this.dockOverviewFacade.cloneDock(+cloneDockId);
    }

    return of(true);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.dockOverviewFacade);
  }
}
